import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { Database } from "@copro/api";
import { keys } from "./keys";

type Command = Database['public']['Tables']['provider_contacts']['Insert'];

async function postProviderContact(command: Command) {
  const { data, error } = await apiClient
    .from('provider_contacts')
    .insert(command)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export default function usePostProviderContact(providerId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (command: Command) => postProviderContact(command),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.getProviderContacts(providerId) });
    },
  });
}
